import { createVNode as e, mergeProps as i } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/UnknownOutlined.js";
import m from "../components/PfIcon.js";
const n = (t, o) => {
  const r = {
    ...t,
    ...o.attrs
  };
  return e(m, i(r, {
    icon: l
  }), null);
};
n.displayName = "UnknownOutlined";
n.inheritAttrs = !1;
export {
  n as default
};
